<template>
  <div>
    <div class="logo-wrapper" style="padding: 20px; text-align: center;">
      <Logo />
    </div>
    <div class="logo-icon-wrapper">
      <router-link to="/">
        <img
          class="img-fluid"
          src="../../../../assets/images/logo/logo-icon.png"
          alt=""
      /></router-link>
    </div>
    <Nav />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import Logo from './logo.vue';
  import Nav from './nav.vue';

  export default {
    name: 'Sidebar',
    components: {
      Logo,
      Nav,
    },
    computed: {
      ...mapState({
        menuItems: (state) => state.public_menu.data,
        activeoverlay: (state) => state.public_menu.activeoverlay,
      }),
    },
    methods: {
      toggle_sidebar() {
        this.$store.dispatch('public_menu/opensidebar');
        this.$store.state.public_menu.activeoverlay = false;
      },
    },
  };
</script>
